import React from "react";
import { HiOutlineBookOpen } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneBook } from "../../../lib/sysNavigation/SysNavigation";

type BookRow = {
  attraction_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<BookRow>
    type={_TYPES_.BOOK}
    title="Books"
    subtitle="Book entries promoted on the public site."
    icon={<HiOutlineBookOpen className="h-5 w-5" />}
    addRoute="/data/book/add"
    editRoute="/data/book/edit"
    pushOne={pushOneBook}
    dataKey="books"
    countKey="booksCount"
    idField="attraction_id"
  />
);

export default Overview;
